import axios from "axios";

axios.defaults.withCredentials = true;

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const resolveVideo = (url) =>
  axios.post(`${API}/resolve`, { url }, { timeout: 60000 }).then((r) => r.data);

export const resolveBatch = (urls) =>
  axios.post(`${API}/resolve/batch`, { urls }, { timeout: 120000 }).then((r) => r.data.results);

export const exchangeSession = (session_id) =>
  axios.post(`${API}/auth/session`, { session_id }).then((r) => r.data);

export const fetchMe = () => axios.get(`${API}/auth/me`).then((r) => r.data);

export const logoutSession = () => axios.post(`${API}/auth/logout`);

export const submitRating = (stars) =>
  axios.post(`${API}/rate`, { stars }).then((r) => r.data);

export const fetchRating = () => axios.get(`${API}/rating`).then((r) => r.data);

export const downloadUrl = (id, kind, quality) =>
  `${API}/download/${id}?kind=${kind}&quality=${quality}`;

export const coverUrl = (id) => `${API}/cover/${id}`;
